import {Cookie} from "./Cookie";

export class ThemePopup {

    static init() {
        if (!ThemePopup.canShow()) {
            return;
        }

        ThemePopup.handleScrollShow();
        ThemePopup.handleCta();
        ThemePopup.handleDismiss();
    }

    static handleScrollShow() {
        var $ = jQuery;
        var shown = false;

        var showPopup = function () {
            if (shown) {
                return;
            }

            shown = true;
            $(window).off('scroll.themePopup');

            if (typeof MicroModal !== 'undefined') {
                MicroModal.show('theme-popup-modal');
            }
        };

        var checkScroll = function () {
            var scrollTop = $(window).scrollTop();
            var docHeight = $(document).height() - $(window).height();

            if (docHeight <= 0 || scrollTop >= docHeight / 2) {
                showPopup();
            }
        };

        $(window).on('scroll.themePopup', checkScroll);
        checkScroll();
    }

    static handleCta() {
        var $ = jQuery;

        $('.js-theme-popup-cta').on('click', function (event) {
            event.preventDefault();
            var url = $(this).attr('href');
            var target = $(this).attr('target') || '_self';

            ThemePopup.dismiss();

            if (!url) {
                return;
            }

            if (target === '_blank') {
                window.open(url, '_blank', 'noopener,noreferrer');
                return;
            }

            window.location.href = url;
        });
    }

    static handleDismiss() {
        var $ = jQuery;

        $('.js-theme-popup-dismiss').on('click', function () {
            ThemePopup.dismiss();
        });
    }

    static dismiss() {
        ThemePopup.setDismissCookie();

        if (typeof MicroModal !== 'undefined') {
            MicroModal.close('theme-popup-modal');
        }
    }

    static setDismissCookie() {
        var cookieName = vosveteit.theme_popup_cookie_name;
        var cookieDays = parseInt(vosveteit.theme_popup_cookie_days, 10);

        if (!cookieName) {
            return;
        }

        if (isNaN(cookieDays) || cookieDays < 1) {
            cookieDays = 7;
        }

        Cookie.setCookie(cookieName, '1', cookieDays);
    }

    static canShow() {
        var cookieName = vosveteit.theme_popup_cookie_name;

        if (!cookieName || !$('#theme-popup-modal').length) {
            return false;
        }

        return !Cookie.getCookie(cookieName);
    }
}
